import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import Header from "./components/Header";
import Landing from "./pages/Landing";
import Footer from "./components/Footer";
import ScrollToTopButton from "./components/ScrollToTopButton";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import GuestProduct from "./pages/GuestProduct/GuestProduct";
import SignIn from "./pages/SignIn/SignIn.js";
// import HowToOrder from "./pages/HowToOrder/index";

import Products from "./pages/Products";

// import Category1 from "./pages/Categories/Category1";
// import Category2 from "./pages/Categories/Category2";
// import Category3 from "./pages/Categories/Category3";

import ProtectedRoute from "./components/ProtectedRoute";

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 768, // Custom breakpoint for small screens
      md: 1024, // Custom breakpoint for medium screens
      lg: 1300, // Custom breakpoint for large screens
      xl: 1500, // Custom breakpoint for extra-large screens
    },
  },
});

// Admin Layout component without Navbar and Footer
const AdminLayout = ({ children }) => {
  return (
    <>
      <Header />
      {children}
      <ScrollToTopButton />
    </>
  );
};

// Public Layout component with Navbar and Footer
const PublicLayout = ({ children }) => {
  return (
    <>
      <Navbar />
      <Header />
      {children}
      <Footer />
      <ScrollToTopButton />
    </>
  );
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route
            path="/"
            element={
              <PublicLayout>
                <Landing />
              </PublicLayout>
            }
          />
          <Route
            path="/sign-in"
            element={
              <PublicLayout>
                <SignIn />
              </PublicLayout>
            }
          />
          <Route
            path="/products-preview"
            element={
              <PublicLayout>
                <GuestProduct />
              </PublicLayout>
            }
          />

          {/* Admin Routes */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Navigate to="/products" replace />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/products"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Products />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          {/*<Route path="/how-to-order" element={<HowToOrder />} />
          <Route path="/category1" element={<Category1 />} />
          <Route path="/category2" element={<Category2 />} />
          <Route path="/category3" element={<Category3 />} />*/}
          {/* Add other routes as needed */}
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
